module.exports = __webpack_public_path__ + "img/Type12insertanvil-min.e3434ef8.png";